import type { IconData } from '@stacksjs/iconify-core'

export const alignRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64h480v32H16zm152 88h328v32H168zM16 240h480v32H16zm152 88h328v32H168zM16 416h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default alignRight
